/** @format */

import { Box, ButtonProps, Text, Flex } from '@chakra-ui/react';
import { ClipLoader } from 'react-spinners';
import { Colors } from '../../utils/constants';
import { IButton } from '../../types';

// eslint-disable-next-line react/prop-types

const Button = ({
  text,
  px,
  py,
  bg,
  color,
  borderRadius,
  border,
  type,
  width,
  maxWidth,
  handleClick,
  fontSize,
  fontWeight,
  hover,
  isLoading,
  isDisabled,
  disabled,
  ...rest
}: IButton) => {
  return (
    <Box
      as='button'
      type={type || 'submit'}
      px={px}
      maxWidth={maxWidth}
      width={width}
      bg={isLoading || disabled ? Colors.gray : bg || Colors.green}
      borderRadius={borderRadius || '0.25rem'}
      border={border || 'hidden'}
      py={py || '8px'}
      fontSize={fontSize || '14px'}
      onClick={handleClick}
      fontWeight={fontWeight || '500'}
      fontFamily='Poppins'
      letterSpacing='0.1px'
      {...((isDisabled || disabled || isLoading) && { pointerEvents: 'none' })}
      _hover={{
        bg: isLoading ? Colors.gray : hover || Colors.secondaryGreen,
        color: color || Colors.white,
      }}
      {...rest}
    >
      {isLoading && (
        <Flex width='100%' justify='center' align='center'>
          <ClipLoader size={'20px'} color='grey' />
        </Flex>
      )}
      {!isLoading && (
        <Text
          fontWeight={fontWeight}
          fontSize={fontSize}
          color={color || 'white'}
          lineHeight={'16px'}
        >
          {text}
        </Text>
      )}
    </Box>
  );
};

export default Button;
